export function repeatTask<T>(times: number, task: () => Promise<T>): Promise<T> {
  if (times <= 1) {
    return task();
  }

  return task().catch(() => repeatTask(times - 1, task));
}
